/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NextAppointmentDateRange/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaInputDateRange from 'DesignSystem/TysiaInputDateRange/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NextAppointmentDateRange({
  children,
  viewPath = "/App/Account/Content/Orders/Filters/NextAppointmentDateRange",
  onChange
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let daterangeValueData = fromData.useDataValue({ viewPath,
context: 'daterange',
})
let daterangeChangeData = fromData.useDataChange({ viewPath,
context: 'daterange',
})
let daterangeTemplatesValueData = fromData.useDataValue({ viewPath,
context: 'daterange',
path: 'templates',
})
  return (<React.Fragment
>
<div
  data-testid="NextAppointmentDateRange.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-Z1nL3iV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaInputDateRange
  viewPath={`${viewPath}/TysiaInputDateRange`}
 label="Date of next appointment"
 width={220}
 size="small"
 data="daterange"
 daterange={daterangeValueData}
 onChange={daterangeChangeData}
 data="daterange.templates"
 templates={daterangeTemplatesValueData}
/>
</div>
{children}
</React.Fragment>)
}